import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SystemSalaryEntity } from '../../domain/entities/SystemSalaryEntity'
import type { SalarySystemAdminDto } from '@/backend/market'
export class SystemSalaryModel extends SystemSalaryEntity {
  constructor(dataDto: SalarySystemAdminDto) {
    super()
    mapEntityProperties<SystemSalaryEntity>(this, dataDto)
  }
}
